import React from 'react';
import {
  getAllSearchParams,
  getSearchParams,
} from '../../commons/models/params';

export default function HeaderGridPrintTemplate(props) {
  let params = getAllSearchParams(props.location);

  return params.map((param, i) => (
    <div key={i} style={{ position: 'absolute', top: '10px', left: '10px' }}>
      {param} {getSearchParams(param, props.location)}
    </div>
  ));
}
